import { useCustomerApplicationsRetrieveSuspense } from "@boundless/bl-api-client/customer/services"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { useStore } from "zustand/react"

import { ApplicationFlowContext } from "@/lib/flows/application"
import { store } from "@/lib/store"

export const Route = createFileRoute(
  "/_dashboard/_application-flow/applications/$applicationUuid",
)({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["applications.view_application"])) {
      throw redirect({ to: "/" })
    }
  },
})

function RouteComponent() {
  const activeCompanyUuid = useStore(store, (state) => state.activeCompanyUuid)
  if (!activeCompanyUuid) {
    throw redirect({ to: "/" })
  }

  const applicationFlow = ApplicationFlowContext.useActorRef()
  const { applicationUuid } = Route.useParams()
  const { data: application } = useCustomerApplicationsRetrieveSuspense(
    activeCompanyUuid,
    applicationUuid,
  )

  applicationFlow.send({ type: "setApplication", application })

  return <Outlet />
}
